import { Link } from "react-router-dom";
export default function Gallery() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <div className="page-head">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Gallery</li>
            </ol>
            <h1>Gallery</h1>
            <p className="text-mono" style={{ color: "#B9C0F0" }}>
              Classroom sessions, events and training snapshots.
            </p>
          </div>
        </div>

        <section className="section bg-paper">
          <div className="container">
            <div className="section-head">
              <h2>OUR CLASSROOM SNAPSHOTS</h2>
            </div>
            <div className="row gallery-grid">
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-1.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E</span>
                <img
                  src="assets/website/img/gallery-1.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-3.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-2.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-3.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-4.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-5.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-2.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-1.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            {/* <div className="section-head">
              <span className="kicker">Branch snapshots</span>
              <h2>Second Branch</h2>
            </div> */}
            <div className="row gallery-grid">
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-4.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-2.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-5.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-5.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-3.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
              <div className="col-6 col-md-4">
                <span className="gallery-branch-tag">L2E </span>
                <img
                  src="assets/website/img/gallery-4.jpg"
                  alt="L2E "
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
}
